<template>
    <Page :header="(!isPWA && !isTgApp) ? header[lang_].title : ''" type="gray">
        <template v-slot:body>
            <Transactions :transactions="transactions" :skip="skip" :total="total" :loading="loading"    
                @update:first="updateSkip"/>
        </template>
    </Page>
</template>

<script>
import Connect from         '@/assets/js/Connect'
import Helper from          '@/assets/js/Helper'
import { useRoute } from    'vue-router'
import Page         from    '@/components/sides/Page.vue' 
import Transactions from    '@/components/personal/Transactions.vue'
import { mapActions } from  'vuex'

export default {
    data() {
        return {
            header: {
                ru: { title: 'Транзакции' },
                en: { title: 'Transactions' },
            },
            content: {
                ru: { 
                    error: 'Ошибка',
                    notfound: 'Транзакции не найдены'
                },
                en: { 
                    error: 'Error' ,
                    notfound: 'Transactions not found'
                }
            },
            wallet_type: null,
            transactions: null,
            total: 0,
            loading: false,
            skip: 0,
        }
    },
    components: {
        Page,
        Transactions
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        isPWA: function () { return this.$store.getters.StatePWA },
    },
    methods: {
        ...mapActions(['SetHeaderTitle', 'SetHeaderBtnLeftFirst', 'SetHeaderBtnLeftSecond', 'SetHeaderBtnRightFirst', 'SetHeaderBtnRightSecond']),
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
        updateSkip(val){
            this.skip = val
            this.loadTransactions()
        },
        async loadTransactions(){
            try {
                this.loading = true
                const transactions = await this.connect.GetUserTransByWalletType(this.wallet_type, this.skip).then(res=>res)
                if(transactions.result && transactions.data) {
                    this.transactions = transactions.data
                    this.total = (transactions.total) ? transactions.total : 0
                }
                else {
                    this.transactions = []
                    this.total = 0
                    this.showMess('error', this.content[this.lang_].error, this.content[this.lang_].notfound)
                }
                window.scrollTo({ top: 0, behavior: 'smooth' })
                this.loading = false
            } catch (error) {
                console.log(error)
                this.loading = false
            }
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    async mounted() {
        this.helper.SetTgAppHeadColor('white', this.isDarkTheme)
        this.helper.SetTgAppBackButton(false)
        const route = useRoute()
        if(route.params.type && route.params.type!=''){
            this.wallet_type = route.params.type
            await this.loadTransactions()
        }

        try {
            this.SetHeaderTitle(this.header[this.lang_].title)
            this.SetHeaderBtnLeftFirst({
                type: 'backward',
                icon: 'pi pi-arrow-left',
                class: 'text-xs',
                rounded: true,
                severity: 'secondary',
                visible: true,
            })
            this.SetHeaderBtnLeftSecond({})
            this.SetHeaderBtnRightFirst({
                class: 'text-xs opacity-0',
                visible: true,
            })
            this.SetHeaderBtnRightSecond({})
        } catch (error) {
            console.error('Error setting header:', error)
        }
    }
}
</script>